import { render, staticRenderFns } from "./otp.vue?vue&type=template&id=f9ecd96e&scoped=true"
import script from "./otp.vue?vue&type=script&lang=js"
export * from "./otp.vue?vue&type=script&lang=js"
import style0 from "./otp.vue?vue&type=style&index=0&id=f9ecd96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ecd96e",
  null
  
)

export default component.exports